import { style } from '@vanilla-extract/css';

export const soundButton = style([
  {
    minWidth: 125,
  },
]);
